import { createAction } from '@lingoda/core';

export default createAction<string>('student/DISABLE_NOTIFICATION');
